import styled from 'styled-components'
import { authCard, authForm, authHeader, authScreen } from '../auth-card'

// The same card as sign in, sign up and recover password: logo and title, no rule underneath.
export default styled.article`
  ${ authScreen }

  form {
    ${ authCard }

    ${ authHeader }

    .backButton {
      width: 20px;
      height: 20px;
      margin: 0 0 20px 0;
      display: block;
      cursor: pointer;
      align-self: flex-start;
    }

    ${ authForm }
  }
`
